import cx from "classnames"
import { useEffect, useState } from "react"

// Components
import Minus from "@/components/common/icons/minus"
import Plus from "@/components/common/icons/plus"

const QuantityInput = ({
  minimum = 1,
  maximum = 99,
  defaultQty = 1,
  setCurrentQty = null,
  className,
  isDisabled
}) => {
  const [quantity, setQuantity] = useState(defaultQty)

  const classNames = cx("quantity-input", className)

  // FIXME these should be moved to css module
  const buttonClasses = cx(
    "flex justify-center w-full sm:w-10 h-full transition duration-200 border-2 border-transparent rounded outline-none cursor-pointer bg-summer-green-75 hover:bg-summer-green-50 hover:border-summer-green-100 disabled:cursor-not-allowed disabled:bg-black-100/10"
  )

  useEffect(() => {
    setQuantity(defaultQty)
  }, [defaultQty])

  useEffect(() => {
    if (!setCurrentQty) {
      return
    }
    setCurrentQty(quantity)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [quantity])

  const handleDecrement = () => {
    if (quantity <= minimum) {
      return
    }
    setQuantity(parseInt(quantity) - 1)
  }

  const handleIncrement = () => {
    if (quantity >= maximum) {
      return
    }
    setQuantity(parseInt(quantity) + 1)
  }

  const handleQuantityChange = (e) => {
    const value = parseInt(e.target.value)

    if (isNaN(value)) {
      return setQuantity("")
    }

    if (value <= minimum) {
      setQuantity(minimum)
      return
    }

    if (value >= maximum) {
      setQuantity(maximum)
      return
    }

    setQuantity(value)
  }

  const handleQuantityOnBlur = () => {
    if (!quantity) {
      setQuantity(defaultQty)
      return
    }

    if (quantity < minimum) {
      setQuantity(minimum ? minimum : 1)
      return
    }

    if (quantity > maximum) {
      setQuantity(maximum)
      return
    }
  }

  return (
    <div className={classNames}>
      <div className="relative flex flex-row h-12 bg-transparent sm:h-full">
        <button
          type="button"
          aria-label="Minska"
          disabled={quantity <= minimum || isDisabled}
          onClick={handleDecrement}
          title="Minska antal med 1"
          className={buttonClasses}>
          <Minus className="flex self-center w-3 transform" />
        </button>
        <input
          type="text"
          inputMode="numeric"
          pattern="[0-9]*"
          disabled={isDisabled}
          className="flex items-center w-20 font-serif font-bold text-center transition-opacity bg-transparent sm:w-10 leading-light number-appearance-none"
          name="quantity-input"
          onChange={handleQuantityChange}
          onBlur={handleQuantityOnBlur}
          value={quantity}></input>
        <button
          type="button"
          aria-label="Öka"
          onClick={handleIncrement}
          disabled={quantity >= maximum || isDisabled}
          title="Öka antal med 1"
          className={buttonClasses}>
          <Plus className="flex self-center w-3" />
        </button>
      </div>
    </div>
  )
}

export default QuantityInput
